import gql from 'graphql-tag';
import {DeleteEntityV2Mutation} from '__generated__/graphql/types';

/** Side effects of entity deletion; action distinguishes deleted records from retained, updated records. */
export default gql`
    mutation DeleteEntityV2($_id: ID!, $tpID: ID!, $_rev: ID) {
        deleteEntityV2(_id: $_id, tpID: $tpID, _rev: $_rev) {
            _id classType deletedTs action blocker blockingReason
        }
    }
`;

export type DeletionSummary = DeleteEntityV2Mutation['deleteEntityV2'][number];
